import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2)
    }
  })
);

export interface TabConfig {
  label: string;
  component: JSX.Element;
}

export const TabsView = (props: {
  list: TabConfig[];
  onChange?: () => void;
}) => {
  const [value, setValue] = React.useState(0);
  const [component, setComponent] = React.useState(
    props.list.length > 0 ? props.list[0].component : <></>
  );
  const classes = useStyles();

  const onChange = (event: React.ChangeEvent<Object>, newValue: number) => {
    if (props.onChange) {
      props.onChange();
    }
    setValue(newValue);
    setComponent(props.list[newValue].component);
  };

  return (
    <div className={classes.title}>
      <Tabs
        value={value}
        onChange={onChange}
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        style={{ display: "inline-block" }}
      >
        {props.list.map(value => {
          return <Tab label={value.label} key={value.label} />;
        })}
      </Tabs>
      {component}
    </div>
  );
};
